import { CommonModule } from '@angular/common';
import { Component, ElementRef, forwardRef, Input, Provider, ViewChild } from '@angular/core';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

const INLINE_EDITOR_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InlineEditorComponent),
  multi: true,
};

@Component({
  selector: 'inline-editor-lib',
  imports: [CommonModule, FormsModule, MatDialogTitle, MatIconModule, ReactiveFormsModule, MatTooltipModule],
  templateUrl: './inline-editor.component.html',
  styleUrl: './inline-editor.component.css',
  providers: [INLINE_EDITOR_VALUE_ACCESSOR],
})
export class InlineEditorComponent {
  @Input() editIconTooltip: string | undefined;
  @Input() viewHeader: string | undefined;
  @Input() editHeader: string | undefined;
  @Input() allowEdit = false;
  @Input() showEditIcon = false;
  @Input() placeholder: string | undefined;
  @Input() viewOpacity: number | undefined;
  @Input() set errorMessage(errorMessage: string | undefined) {
    this.error = errorMessage;
    if (this.error) {
      this.onEdit();
    }
  }

  formControl = new FormControl();
  value: any;
  editing = false;
  disabled = false;
  error: string | undefined;

  @ViewChild('editInput') editInput: ElementRef | undefined;

  onEdit(): void {
    this.setEditing(true);
    setTimeout(() => {
      this.editInput?.nativeElement.focus();
    });
  }

  // ControlValueAccessor methods
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
    this.formControl.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;

    // Subscribe to value changes of internal control
    this.formControl.valueChanges.subscribe((value) => {
      this.value = value;
      this.onChange(value);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  setEditing(editing: boolean): void {
    if (!editing && this.error) {
      this.onEdit();
      return;
    }
    this.editing = editing;
  }
}
